module.exports = __webpack_public_path__ + "static/media/AnastasiosThomaidis.97141aff.jpg";